import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { cloneDeep } from 'lodash-es';
import { eachDayOfInterval, format, parse, addWeeks, subWeeks, addDays, set, differenceInCalendarDays } from 'date-fns';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { CorporateApi, ProductApi, ScheduleApi } from "@/apis";
import EntryCalendar from "@/components/EntryCalendar.vue";
import { DATETIME_FORMAT, SCHEDULE_STATUS_CNST, ENTRY_DEADLINE_DAYS } from '@/constants/constants';
import { ja } from "date-fns/locale";
export var INITIAL_SCHEDULE_SEARCH_CONDITION = {
    id: { enabled: false, value: 0 },
    corporateID: { enabled: false, value: 0 },
    memberID: { enabled: false, value: 0 },
    placeID: { enabled: false, value: 0 },
    startDateTimeFrom: { enabled: false, value: '' },
    startDateTimeTo: { enabled: false, value: '' },
    endDateTime: { enabled: false, value: '' },
    capacity: { enabled: false, value: 0 },
};
export var INITIAL_DATA_TABLE_PAGE_INFO = {
    page: 1,
    itemsPerPage: 100,
    cursors: [],
    sortBy: [],
    sortDesc: [],
};
var ReservationCalendar = /** @class */ (function (_super) {
    __extends(ReservationCalendar, _super);
    function ReservationCalendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.today = new Date();
        _this.baseDay = _this.today;
        _this.corporate = {};
        _this.product = {};
        _this.schedules = [];
        _this.member = null;
        /** スケジュールの時間枠の開始時間一覧 */
        _this.times = ['09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00'];
        _this.days = [];
        _this.timeRows = [];
        _this.searchCondition = INITIAL_SCHEDULE_SEARCH_CONDITION;
        _this.selectedScheduleInfo = null;
        _this.selectedSchedule = null;
        _this.isModalOpen = false;
        return _this;
    }
    ReservationCalendar_1 = ReservationCalendar;
    Object.defineProperty(ReservationCalendar.prototype, "isThisWeek", {
        get: function () {
            if (this.baseDay <= this.today) {
                return true;
            }
            else {
                return false;
            }
        },
        enumerable: false,
        configurable: true
    });
    ReservationCalendar.prototype.formatDay = function (day) {
        return format(day, DATETIME_FORMAT.MMDD, { locale: ja });
    };
    ReservationCalendar.prototype.formatDayOfWeek = function (day) {
        return format(day, DATETIME_FORMAT.DAY_OF_WEEK, { locale: ja });
    };
    ReservationCalendar.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        // 全体設定を取得する
                        _a = this;
                        return [4 /*yield*/, new CorporateApi().getCorporate({ id: this.corporateId }).then(function (res) { return res.data; })];
                    case 1:
                        // 全体設定を取得する
                        _a.corporate = (_c.sent()) || {};
                        if (this.corporate.scheduleTimes && this.corporate.scheduleTimes.length > 0) {
                            this.times = this.corporate.scheduleTimes;
                        }
                        // corporateIdを検索条件に設定
                        this.searchCondition.corporateID.value = this.corporateId;
                        this.searchCondition.corporateID.enabled = true;
                        this.$store.commit('setCorporate', this.corporate);
                        // 商品を取得する
                        _b = this;
                        return [4 /*yield*/, new ProductApi().getProductPublic({
                                id: this.productId,
                                corporateId: this.corporateId
                            }).then(function (res) { return res.data; })];
                    case 2:
                        // 商品を取得する
                        _b.product = (_c.sent()) || {};
                        return [4 /*yield*/, this.changeWeek()];
                    case 3:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReservationCalendar.prototype.changeWeek = function () {
        return __awaiter(this, void 0, void 0, function () {
            var start, end;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        start = set(this.baseDay, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
                        end = set(addDays(this.baseDay, 7), { hours: 23, minutes: 59, seconds: 59, milliseconds: 999 });
                        this.days = eachDayOfInterval({ start: start, end: end });
                        this.searchCondition.startDateTimeFrom.value = format(start, DATETIME_FORMAT.FOR_API);
                        this.searchCondition.startDateTimeFrom.enabled = true;
                        this.searchCondition.startDateTimeTo.value = format(end, DATETIME_FORMAT.FOR_API);
                        this.searchCondition.startDateTimeTo.enabled = true;
                        return [4 /*yield*/, this.refresh()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReservationCalendar.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, pageInfo;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ReservationCalendar_1.fetch()];
                    case 1:
                        data = _a.sent();
                        pageInfo = cloneDeep(INITIAL_DATA_TABLE_PAGE_INFO);
                        if (data.cursor) {
                            pageInfo.cursors[0] = data.cursor;
                        }
                        this.schedules = data.schedules || [];
                        this.timeRows = this.times.map(function (time) {
                            var timeRow = {
                                time: time,
                                scheduleInfos: []
                            };
                            timeRow.scheduleInfos = _this.days.map(function (day) {
                                var boxDateTime = format(parse(time, DATETIME_FORMAT.HHMM, day), DATETIME_FORMAT.DATE_TIME);
                                var scheduleInfo = {
                                    time: time,
                                    day: day,
                                    status: 0,
                                    capacity: 0,
                                    schedules: [],
                                };
                                scheduleInfo.schedules = _this.schedules.filter(function (schedule) {
                                    if (schedule.startDateTime) {
                                        var startDateTime = format(new Date(schedule.startDateTime), DATETIME_FORMAT.DATE_TIME);
                                        if (schedule.startDateTime && boxDateTime === startDateTime) {
                                            return schedule;
                                        }
                                    }
                                    return null;
                                }) || [];
                                if (scheduleInfo.schedules.length === 0) {
                                    scheduleInfo.status = SCHEDULE_STATUS_CNST.None;
                                }
                                else if (differenceInCalendarDays(day, new Date()) < ENTRY_DEADLINE_DAYS) {
                                    // 予約受付期限切れ（前日・当日・過去）は空きがあっても選択不可
                                    scheduleInfo.status = SCHEDULE_STATUS_CNST.Expired;
                                }
                                else {
                                    var count_1 = 0;
                                    scheduleInfo.schedules.forEach(function (member) {
                                        if (member.capacity !== undefined && member.applications !== undefined && (member.capacity > member.applications)) {
                                            count_1 = count_1 + (member.capacity - member.applications);
                                        }
                                    });
                                    if (count_1 > 0) {
                                        scheduleInfo.status = SCHEDULE_STATUS_CNST.Possible;
                                        scheduleInfo.capacity = count_1;
                                    }
                                    else {
                                        scheduleInfo.status = SCHEDULE_STATUS_CNST.Full;
                                    }
                                }
                                return scheduleInfo;
                            });
                            return timeRow;
                        }) || [];
                        return [2 /*return*/];
                }
            });
        });
    };
    ReservationCalendar.prototype.prev = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.baseDay = subWeeks(this.baseDay, 1);
                        return [4 /*yield*/, this.changeWeek()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReservationCalendar.prototype.next = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.baseDay = addWeeks(this.baseDay, 1);
                        return [4 /*yield*/, this.changeWeek()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReservationCalendar.prototype.selectMember = function (member) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.member = member;
                        this.searchCondition.memberID.value = member.memberID;
                        this.searchCondition.memberID.enabled = true;
                        return [4 /*yield*/, this.refresh()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReservationCalendar.prototype.resetMember = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.member = null;
                        this.searchCondition.memberID.value = 0;
                        this.searchCondition.memberID.enabled = false;
                        return [4 /*yield*/, this.refresh()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReservationCalendar.fetch = function (_a) {
        var _b = _a === void 0 ? { searchCondition: INITIAL_SCHEDULE_SEARCH_CONDITION, pageInfo: INITIAL_DATA_TABLE_PAGE_INFO } : _a, _c = _b.searchCondition, searchCondition = _c === void 0 ? INITIAL_SCHEDULE_SEARCH_CONDITION : _c, _d = _b.pageInfo, pageInfo = _d === void 0 ? INITIAL_DATA_TABLE_PAGE_INFO : _d;
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, new ScheduleApi().searchSchedule({
                            id: searchCondition.id.enabled ? searchCondition.id.value : undefined,
                            corporateID: searchCondition.corporateID.enabled ? searchCondition.corporateID.value : undefined,
                            memberID: searchCondition.memberID.enabled ? searchCondition.memberID.value : undefined,
                            placeID: searchCondition.placeID.enabled ? searchCondition.placeID.value : undefined,
                            startDateTimeFrom: searchCondition.startDateTimeFrom.enabled ? searchCondition.startDateTimeFrom.value : undefined,
                            startDateTimeTo: searchCondition.startDateTimeTo.enabled ? searchCondition.startDateTimeTo.value : undefined,
                            endDateTime: searchCondition.endDateTime.enabled ? searchCondition.endDateTime.value : undefined,
                            capacity: searchCondition.capacity.enabled ? searchCondition.capacity.value : undefined,
                            limit: pageInfo.itemsPerPage !== -1 ? pageInfo.itemsPerPage : undefined,
                            cursor: pageInfo.page !== 1 ? pageInfo.cursors[pageInfo.page - 2] : undefined,
                            orderBy: pageInfo.sortBy.map(function (sb, i) { return "" + ((pageInfo.sortDesc)[i] ? '-' : '') + sb; }).join(',') || undefined
                        }).then(function (res) { return res.data; })];
                    case 1: return [2 /*return*/, _e.sent()];
                }
            });
        });
    };
    ReservationCalendar.prototype.selectSchedule = function (scheduleInfo) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!scheduleInfo) {
                    return [2 /*return*/, null];
                }
                console.log("select schedule " + scheduleInfo.day + " " + scheduleInfo.time);
                this.selectedScheduleInfo = scheduleInfo;
                if (this.selectedScheduleInfo.schedules.length === 1) {
                    this.selectedSchedule = this.selectedScheduleInfo.schedules[0];
                }
                this.isModalOpen = true;
                return [2 /*return*/];
            });
        });
    };
    ReservationCalendar.prototype.selectReserveMember = function (memberID) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                this.selectedSchedule = ((_a = this.selectedScheduleInfo) === null || _a === void 0 ? void 0 : _a.schedules.find(function (s) { return s.memberID === memberID; })) || null;
                return [2 /*return*/];
            });
        });
    };
    ReservationCalendar.prototype.openLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.selectedSchedule) {
                    window.location.href = process.env.VUE_APP_CES_PATH + "/public/entry/register?scheduleID=" + this.selectedSchedule.id + "&productID=" + this.productId;
                }
                return [2 /*return*/];
            });
        });
    };
    ReservationCalendar.prototype.reserve = function () {
        return __awaiter(this, void 0, void 0, function () {
            var selectedSchedule;
            return __generator(this, function (_a) {
                this.isModalOpen = false;
                if (!this.selectedSchedule) {
                    return [2 /*return*/, null];
                }
                selectedSchedule = this.selectedSchedule;
                this.selectedSchedule = null;
                return [2 /*return*/, selectedSchedule];
            });
        });
    };
    var ReservationCalendar_1;
    __decorate([
        Prop()
    ], ReservationCalendar.prototype, "corporateId", void 0);
    __decorate([
        Prop()
    ], ReservationCalendar.prototype, "productId", void 0);
    __decorate([
        Emit('push')
    ], ReservationCalendar.prototype, "reserve", null);
    ReservationCalendar = ReservationCalendar_1 = __decorate([
        Component({
            components: { EntryCalendar: EntryCalendar }
        })
    ], ReservationCalendar);
    return ReservationCalendar;
}(Vue));
export default ReservationCalendar;
